import React from 'react';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import ContactAvatarGroup from '@components/ContactAvatarGroup/ContactAvatarGroup';

const TaskContactAvatars = ({ task }) => {
    const { TodoContacts } = task;
    const contactIDs = TodoContacts ? TodoContacts.filter((c) => c.ContactID).map((c) => c.ContactID) : [];
    if (contactIDs.length > 0) {
        return (
            <div className="task-contacts">
                <ContactAvatarGroup contactIDs={[...contactIDs]} />
                {contactIDs.length === 1 && <div style={{ marginLeft: '5px' }}>{getContactName(contactIDs[0])}</div>}
            </div>
        );
    }
    return <></>;
};

export default TaskContactAvatars;
